export default "__VITE_ASSET__DBcKxt5A__"